import type { CreateClientConfig } from './client/client';
import { getToken } from '@clerk/react';
import queryString from 'query-string';

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  // Clerk's framework-agnostic token getter — safe outside React and waits
  // for Clerk to initialize, unlike window.Clerk?.session. A null token means
  // the session is gone: the request goes out unauthenticated and the API's
  // 401 triggers the dead-session teardown (helpers/deadSession). A token
  // fetch that *fails* (Clerk unreachable) rethrows so the request never
  // fires — an infrastructure blip must not end the session.
  auth: async () => (await getToken()) || undefined,
  baseURL: import.meta.env.VITE_APP_BASE_URL || '',
  paramsSerializer: (params) => queryString.stringify(params),
});
